<tpl-modal (close)="dismiss()">
  <tpl-modal-header>確認</tpl-modal-header>

  <div class="note" [innerHTML]="message | safeHtml"></div>

  <tpl-re-captcha [siteKey]="siteKey" [action]="action" [formControl]="form"></tpl-re-captcha>
</tpl-modal>
